import React from "react";
import { Link } from "react-router-dom";

const Navbar = () => {
  return (
    <nav className="navbar">
      <h1>
        <Link to="/" className="Docminter">
          Doc Minter
        </Link>
      </h1>
      <div className="links">
        <Link to="/">Home</Link>
        <Link to="/mint" target="_blank">
          Mint
        </Link>
        <Link to="/verify">Verify</Link>
        <Link to="/search">Search</Link>
      </div>
    </nav>
  );
};

export default Navbar;
